<template>
  <div class="save">
    <div class="top" style="margin-bottom: 20px;">
      <Input
        v-model="searchVal"
        placeholder="搜索保存的结果"
        clearable
        style="width: 200px"
        @on-enter="seachSaved(searchVal)"
      />
    </div>
    <div class="save-bottom">

      <u-table
          :data="saveData"
          @row-click="selectRowItem"
          :border="false"   :header-row-class-name="() => 'u-table-class-name'"
          v-if="saveData && saveData.length"
          :max-height="400"
        >
        <u-table-column align="center"
                    v-for="(item, index2) in saveColumns"
                    :key="item.key"
                    :show-overflow-tooltip="true"
                    :prop="item.key"
                    :label="item.title"
                    :min-width="200"
                    >
                    <template slot-scope="scope">
                      <HRender :fn="item.render" v-bind="{row: scope.row, column: {...scope.column, _index: index2, ...item}, index: scope.$index}" v-if="item.render"></HRender>
                      <span v-else>
                        {{ scope.row[item.key] }}
                      </span>
                    </template>
                  </u-table-column>
        </u-table>
      <el-empty v-else></el-empty>
      <!-- <Page
        style="margin-top: 10px; display: flex; justify-content: flex-end"
        :total="savedDtaaList.page.count"

        :page-size="pageSize"
        @on-change="chgPage"
      /> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      searchVal: "",
      saveColumns: [
        {
          title: "名称",
          key: "name",
          width: "150px",
        },
        {
          title: "描述",
          key: "description",
          // width: "500px",
        },
        // {
        //   title: "Owner",
        //   key: "owner",
        //   width: "150px",
        // },
        {
          title: "修改时间",
          key: "modified",
        },
      ],

      saveData: [],

      page: 1,
      pageSize: 10,
    };
  },
  created() {
    // let param = {
    //   projectId: this.projectId,
    //   page: this.page,
    //   pageSize: this.pageSize,
    // };
    this.getSaveStatementAll(this.projectId);
  },
  components: {},
  computed: {
    ...mapState({
      projectId: (state) => state.app.projectId,
      savedDtaaList: (state) => state.customizedQueries.savedDtaaList,
    }),
  },
  mounted() {},
  watch: {
    savedDtaaList(data) {
      this.initSaveData(data);
    },
  },
  methods: {
    ...mapActions(["getSaveStatementAll"]),
    // 格式化时间
    initSaveData(data) {
      this.saveData = [];
      data.forEach((item) => {
        this.saveData.push({
          name: item.name,
          description: item.description,
          modified: this.getYMDHMS(item.createTime),
        });
      });
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, "0");
      const date = time.getDate().toString().padStart(2, "0");
      const hours = time.getHours().toString().padStart(2, "0");
      const minute = time.getMinutes().toString().padStart(2, "0");
      // const second = time.getSeconds().toString().padStart(2, "0");
      // 	03/03/2022 12:28 AM +08:00

      return year + "-" + month + "-" + date + " " + hours + ":" + minute;
    },
    selectSave(content) {
      let saveHis = this.savedDtaaList.filter((item) => {
        return item.name == content.name;
      });
      this.selectRowItem(saveHis[0]);
    },
    // 分页
    // chgPage(index) {
    //   // 查询历史
    //   // let param = {
    //   //   projectId: this.projectId,
    //   //   page: index,
    //   //   pageSize: this.pageSize,
    //   // };
    //   this.getSaveStatementAll(this.projectId);
    // },
    // 选择单行数据
    selectRowItem(el) {
      this.$emit(
        "selectRowItem",
        this.savedDtaaList.filter((res) => {
          return res.name == el.name;
        })
      );
    },
    // 搜索
    //toLowerCase（）方法：将字符串统一转成小写
    // toUpperCase（）方法：将字符串统一转成大写
    seachSaved(searchVal) {
      let data = {
        list: [],
      };
      data.list = this.savedDtaaList.filter(
        (item) =>
          item.name.toLowerCase().indexOf(searchVal.toLowerCase()) != -1 ||
          item.content.toLowerCase().indexOf(searchVal.toLowerCase()) != -1 ||
          item.description.toLowerCase().indexOf(searchVal.toLowerCase()) != -1
      );
      this.initSaveData(data.list);
    },
  },
};
</script>

<style scoped>
.save {
  padding: 0 10px;
}
.save-bottom {
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/save.vue